import { render, staticRenderFns } from "./EquivalencesList.vue?vue&type=template&id=49cd2233&scoped=true&"
import script from "./EquivalencesList.vue?vue&type=script&lang=ts&"
export * from "./EquivalencesList.vue?vue&type=script&lang=ts&"
import style0 from "./EquivalencesList.vue?vue&type=style&index=0&id=49cd2233&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd2233",
  null
  
)

export default component.exports